import * as type from "../types";
import moment from "moment";

const initialState = {
  marketProcesses: {
    listProcess: [],
    loadingProcess: false,
    errorProcess: false,
  },
  generalOperations: {
    list: [],
    loadingGO: false,
    errorGO: false,
  },
  chart: {
    year: moment().format("YYYY"),
    month: moment().format("M"),
    data: [],
    loadingChart: false,
    errorChart: false,
  },
  organizedMarketInfo: {
    info: {},
    loadingInfo: false,
    errorInfo: false,
  },
  systemMsg: {
    listMsg: [],
    activePage: 0,
    totalPageCount: 0,
    loadingMsg: false,
    errorMsg: false,
  },
  objections: {
    listObjections: [],
    loadingObjections: false,
    errorObjections: false,
  },
  bilateralAgreement: {
    listBilateral: [],
    loadingBilateral: false,
    errorBilateral: false,
    listBilateralSAndB: [],
    loadingBilateralSAndB: false,
    errorBilateralSAndB: false,
  },
  productionData: {
    listProduction: [],
    loadingProduction: false,
    errorProduction: false,
  },
  activeCertificates: {
    listCertificates: [],
    loadingCertificates: false,
    errorCertificates: false,
  },
};

const homepage = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_MARKET_PROCESSES_LIST_REQUEST:
      return {
        ...state,
        marketProcesses: {
          ...state.marketProcesses,
          loadingProcess: true,
          errorProcess: false,
        },
      };
    case type.GET_MARKET_PROCESSES_LIST_SUCCEEDED:
      return {
        ...state,
        marketProcesses: {
          ...state.marketProcesses,
          listProcess: action.payload,
          loadingProcess: false,
          errorProcess: false,
        },
      };
    case type.GET_MARKET_PROCESSES_LIST_FAILED:
      return {
        ...state,
        marketProcesses: {
          ...state.marketProcesses,
          loadingProcess: false,
          errorProcess: true,
        },
      };
    case type.GET_GENERAL_OPERATIONS_LIST_REQUEST:
      return {
        ...state,
        generalOperations: {
          ...state.generalOperations,
          loadingGO: true,
          errorGO: false,
        },
      };
    case type.GET_GENERAL_OPERATIONS_LIST_SUCCEEDED:
      return {
        ...state,
        generalOperations: {
          list: action.payload,
          loadingGO: false,
          errorGO: false,
        },
      };
    case type.GET_GENERAL_OPERATIONS_LIST_FAILED:
      return {
        ...state,
        generalOperations: {
          ...state.generalOperations,
          loadingGO: false,
          errorGO: true,
        },
      };
    case type.CLEAR_GENERAL_OPERATIONS_LIST:
      return {
        ...state,
        generalOperations: {
          ...state.generalOperations,
          list: [],
        },
      };
    case type.SET_CHART_TERM:
      const term = action.payload.split("-");
      return {
        ...state,
        chart: {
          ...state.chart,
          year: term[0],
          month: term[1],
        },
      };
    case type.GET_CHART_DATA_REQUEST:
      return {
        ...state,
        chart: {
          ...state.chart,
          loadingChart: true,
          errorChart: false,
        },
      };
    case type.GET_CHART_DATA_SUCCEEDED:
      return {
        ...state,
        chart: {
          ...state.chart,
          data: action.payload,
          loadingChart: false,
          errorChart: false,
        },
      };
    case type.GET_CHART_DATA_FAILED:
      return {
        ...state,
        chart: {
          ...state.chart,
          loadingChart: false,
          errorChart: true,
        },
      };
    case type.GET_ORGANIZED_MARKET_INFO_REQUEST:
      return {
        ...state,
        organizedMarketInfo: {
          ...state.organizedMarketInfo,
          loadingInfo: true,
          errorInfo: false,
        },
      };
    case type.GET_ORGANIZED_MARKET_INFO_SUCCEEDED:
      return {
        ...state,
        organizedMarketInfo: {
          info: action.payload,
          loadingInfo: false,
          errorInfo: false,
        },
      };
    case type.GET_ORGANIZED_MARKET_INFO_FAILED:
      return {
        ...state,
        organizedMarketInfo: {
          ...state.organizedMarketInfo,
          loadingInfo: false,
          errorInfo: true,
        },
      };
    case type.GET_SYSTEM_MSG_LIST_REQUEST:
      return {
        ...state,
        systemMsg: {
          ...state.systemMsg,
          loadingMsg: true,
          errorMsg: false,
        },
      };
    case type.GET_SYSTEM_MSG_LIST_SUCCEEDED:
      return {
        ...state,
        systemMsg: {
          listMsg: action.payload.items,
          activePage: action.payload.activePage,
          totalPageCount: action.payload.totalPageCount,
          loadingMsg: false,
          errorMsg: false,
        },
      };
    case type.GET_SYSTEM_MSG_LIST_FAILED:
      return {
        ...state,
        systemMsg: {
          ...state.systemMsg,
          loadingMsg: false,
          errorMsg: true,
        },
      };
    case type.GET_HOME_OBJECTIONS_LIST_REQUEST:
      return {
        ...state,
        objections: {
          ...state.objections,
          loadingObjections: true,
          errorObjections: false,
        },
      };
    case type.GET_HOME_OBJECTIONS_LIST_SUCCEEDED:
      return {
        ...state,
        objections: {
          listObjections: action.payload,
          loadingObjections: false,
          errorObjections: false,
        },
      };
    case type.GET_HOME_OBJECTIONS_LIST_FAILED:
      return {
        ...state,
        objections: {
          ...state.objections,
          loadingObjections: false,
          errorObjections: true,
        },
      };
    case type.GET_HOME_BILATERAL_LIST_REQUEST:
      return {
        ...state,
        bilateralAgreement: {
          ...state.bilateralAgreement,
          loadingBilateral: true,
          errorBilateral: false,
        },
      };
    case type.GET_HOME_BILATERAL_LIST_SUCCEEDED:
      return {
        ...state,
        bilateralAgreement: {
          ...state.bilateralAgreement,
          listBilateral: action.payload,
          loadingBilateral: false,
          errorBilateral: false,
        },
      };
    case type.GET_HOME_BILATERAL_LIST_FAILED:
      return {
        ...state,
        bilateralAgreement: {
          ...state.bilateralAgreement,
          loadingBilateral: false,
          errorBilateral: true,
        },
      };
    case type.GET_BILATERAL_SANDB_LIST_REQUEST:
      return {
        ...state,
        bilateralAgreement: {
          ...state.bilateralAgreement,
          loadingBilateralSAndB: true,
          errorBilateralSAndB: false,
        },
      };
    case type.GET_BILATERAL_SANDB_LIST_SUCCEEDED:
      return {
        ...state,
        bilateralAgreement: {
          ...state.bilateralAgreement,
          listBilateralSAndB: action.payload,
          loadingBilateralSAndB: false,
          errorBilateralSAndB: false,
        },
      };
    case type.GET_BILATERAL_SANDB_LIST_FAILED:
      return {
        ...state,
        bilateralAgreement: {
          ...state.bilateralAgreement,
          loadingBilateralSAndB: false,
          errorBilateralSAndB: true,
        },
      };
    case type.GET_HOME_PRODUCTION_DATA_REQUEST:
      return {
        ...state,
        productionData: {
          ...state.productionData,
          loadingProduction: true,
          errorProduction: false,
        },
      };
    case type.GET_HOME_PRODUCTION_DATA_SUCCEEDED:
      return {
        ...state,
        productionData: {
          listProduction: action.payload,
          loadingProduction: false,
          errorProduction: false,
        },
      };
    case type.GET_HOME_PRODUCTION_DATA_FAILED:
      return {
        ...state,
        productionData: {
          ...state.productionData,
          loadingProduction: false,
          errorProduction: true,
        },
      };
    case type.GET_HOME_ACTIVE_CERTIFICATES_REQUEST:
      return {
        ...state,
        activeCertificates: {
          ...state.activeCertificates,
          loadingCertificates: true,
          errorCertificates: false,
        },
      };
    case type.GET_HOME_ACTIVE_CERTIFICATES_SUCCEEDED:
      return {
        ...state,
        activeCertificates: {
          listCertificates: action.payload,
          loadingCertificates: false,
          errorCertificates: false,
        },
      };
    case type.GET_HOME_ACTIVE_CERTIFICATES_FAILED:
      return {
        ...state,
        activeCertificates: {
          ...state.activeCertificates,
          loadingCertificates: false,
          errorCertificates: true,
        },
      };
    default:
      return state;
  }
};

export default homepage;
